module.exports = __webpack_public_path__ + "static/media/fz_mthview_pt_PT.bda06cee.png";